import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as o } from "../constants.js";
const t = (t2, r) => {
  const a = e({ reducerPath: "nodeSealLocationApi", baseQuery: r({ baseUrl: `${t2}/seal-locations` }), keepUnusedDataFor: o, endpoints: (e2) => ({ getNodeSealLocation: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetNodeSealLocationQuery: n } = a;
  return { nodeSealLocationApi: a, useGetNodeSealLocationQuery: n };
};
export {
  t as initializeNodeSealLocationsApi
};
//# sourceMappingURL=nodeSealLocationApi.js.map
